var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_user_role",
          attrs: {
            id: "modal-user-role",
            title: _vm.newItem.name === "" ? "Новая роль" : _vm.newItem.name,
            size: "lg",
            "modal-class": "custom-modal",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.onCancel }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.loading || _vm.isDisabled },
                          on: { click: _vm.onOk }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n          Сохранить\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "lg" } },
                          [
                            _c("b-skeleton", {
                              staticClass: "mb-2",
                              attrs: { width: "5%", height: "22%" }
                            }),
                            _vm._v(" "),
                            _c("b-skeleton", {
                              staticClass: "mb-3",
                              attrs: {
                                type: "input",
                                width: "100%",
                                height: "36%"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c("b-skeleton", {
                              staticClass: "pt-2 mb-2",
                              attrs: { width: "12%", height: "22%" }
                            }),
                            _vm._v(" "),
                            _c("b-skeleton", {
                              attrs: {
                                type: "input",
                                width: "100%",
                                height: "44%"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-form-group",
                      { attrs: { id: "group-user-name", label: "Роль" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            size: "sm",
                            placeholder: "Введите название роли",
                            state: _vm.getFieldState("name")
                          },
                          on: { input: _vm.generateCode },
                          model: {
                            value: _vm.newItem.name,
                            callback: function($$v) {
                              _vm.$set(_vm.newItem, "name", $$v)
                            },
                            expression: "newItem.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: { id: "group-user-role-active", label: "Статус" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "ant-switch-wrapper mr-2" },
                              [
                                _c("b-form-checkbox", {
                                  staticClass: "m-0",
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    "aria-label": _vm.newItem.active
                                      ? "Отключить роль"
                                      : "Включить роль",
                                    switch: ""
                                  },
                                  model: {
                                    value: _vm.newItem.active,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "active", $$v)
                                    },
                                    expression: "newItem.active"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "switch-icons-overlay" },
                                  [
                                    _c("v-icon", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.newItem.active,
                                          expression: "newItem.active"
                                        }
                                      ],
                                      staticClass: "ml-2",
                                      staticStyle: { color: "#fff" },
                                      attrs: { name: "buttons/check", size: 11 }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.newItem.active,
                                          expression: "!newItem.active"
                                        }
                                      ],
                                      staticClass: "flex-grow-1"
                                    }),
                                    _vm._v(" "),
                                    _c("v-icon", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.newItem.active,
                                          expression: "!newItem.active"
                                        }
                                      ],
                                      staticClass: "mr-2",
                                      staticStyle: { color: "#fff" },
                                      attrs: { name: "buttons/cross", size: 10 }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.newItem.active ? "Активна" : "Неактивна"
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "group-user-permissions",
                          label: "Разрешения"
                        }
                      },
                      [
                        _c(
                          "b-list-group",
                          {
                            staticClass: "text-small",
                            attrs: { "bg-variant": "light" }
                          },
                          _vm._l(_vm.treeData, function(item, index) {
                            return _c("PermissionListItem", {
                              key: index,
                              attrs: {
                                item: item,
                                "tree-data": _vm.treeData,
                                "is-disabled": _vm.isDisabled,
                                "role-code": _vm.newItem.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5e78550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5e78550","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserRole.vue
// module id = null
// module chunks = 